<div class="p-4">
	<div class="modal-header border-0 p-0">
		<h2 class="fs-kd-button text-kd-danger" translate>Attenzione</h2>
		<i class="fa-solid fa-xmark fa-lg text-kd-dark" (click)="modal.close()"></i>
	</div>
	<div class="modal-body">
		<div class="confirm-delete">
			<p class="fs-kd-bold text-kd-dark">{{message}}</p>
			@if (erroreHttp) {
				<div class="text-start fs-kd-normal">
					Url: {{erroreHttp.url}}
					<br />
					{{'Codice Errore' | translate}}: {{erroreHttp.status}} - {{erroreHttp.statusText}}
					@if (erroreHttp.error) {
						<pre [innerHTML]="erroreHttp.error | json"></pre>
					}
				</div>
			}
			<div class="d-flex flex-column w-100 mt-4">
				@if (hrefInvioMail) {
					<a type="button" class="btn btn-kd-primary px-3 mb-3 pt-2" [href]="hrefInvioMail">
						{{'Invia segnalazione' | translate}}
					</a>
				}
				<button type="button" class="btn btn-kd-secondary btn-outline px-3" (click)="modal.close()">{{'Chiudi' | translate}}</button>
			</div>
		</div>
	</div>
</div>
